export default function number(num) {
    if (+num === NaN) return num;
    return +(num * 100).toFixed(0);
};